module.exports = __webpack_public_path__ + "static/media/OnlineTask.4e8cf6df.svg";